var path = '/templates/projects.campaigns/views/directives/campaign_notes.html';
var html = "<div class=col-md-12><div class=row style=\"margin-bottom: 20px;\" ng-repeat=\"(noteName, noteText) in vm.getNotes()\"><b>{{vm.translateNoteName(noteName)}}</b><pre ng-style=vm.textWrap style=\"max-height: 400px; padding: 5px; white-space: pre-line;\">{{noteText || '-'}}</pre></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/campaign_notes.html
// module id = 1377
// module chunks = 0